<div class="container-fluid">
  <div class="row manageaccount mt-3">
    <div class="col-md-12 my-auto">
      <div class="d-flex align-items-baseline justify-content-between">
        <h1 class="fs-4 fw-bold mb-0">View LR</h1>
        <button
          class="btn btn-dark btn-sm"
          matTooltip="Back"
          matTooltipPosition="left"
          mat-raised-button
          (click)="backTo()"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>
      <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item" routerLink="/superAdmin/lrmanagement">
            Manage LR
          </li>
          <li class="breadcrumb-item active" aria-current="page">View LR</li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-xl-12">
      <form [formGroup]="editLR">
        <div class="contentbox">
          <!-- Basic Details -->
          <div class="row account">
            <div class="col-xl-12 mb-4">
              <div class="detailsBox">
                <h4>Basic Details ({{ particlarLR?.LR_no ?? "N/A" }})</h4>
                <div class="row">
                  <div class="col-xl-3 mb-3">
                    <label>Manual LR No.</label>
                    <h5>{{ particlarLR?.manualLR_no ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>System LR No.</label>
                    <h5>{{ particlarLR?.LR_no ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Supervisor Name</label>
                    <h5>{{ particlarLR?.supervisorName ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Company Name</label>
                    <h5>{{ particlarLR?.clientName ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Consignor Name</label>
                    <h5>{{ particlarLR?.consignor_name ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Consignor Address</label>
                    <h5>{{ particlarLR?.consignor_address ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Consignee Name</label>
                    <h5>{{ particlarLR?.consignee_name ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Consignee Address</label>
                    <h5>{{ particlarLR?.consignee_address ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Vehicle No</label>
                    <h5>{{ particlarLR?.vehicle_id ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Vehicle Type</label>
                    <h5>{{ particlarLR?.vehicleType ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>From</label>
                    <h5>{{ particlarLR?.from ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>To</label>
                    <h5>{{ particlarLR?.to ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>GSTIN</label>
                    <h5>{{ particlarLR?.GSTIN ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Date</label>
                    <h5>{{ particlarLR?.date | date : "mediumDate" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Road Permit No</label>
                    <h5>{{ particlarLR?.road_permit_no ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Quantity/Weight</label>
                    <h5>{{ particlarLR?.quantity ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Transporter Name</label>
                    <h5>{{ particlarLR?.transportorName ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Transporter Mobile</label>
                    <h5>{{ particlarLR?.transportorMobile ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Driver Name</label>
                    <h5>{{ particlarLR?.driverName ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Driver Mobile</label>
                    <h5>{{ particlarLR?.driverMobile ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Freight</label>
                    <h5>{{ particlarLR?.Frieght ?? "N/A" }}</h5>
                  </div>

                  <div class="col-xl-3 mb-3">
                    <label>Trip Start Date</label>
                    <h5>
                      {{
                        particlarLR?.tripEndDate
                          ? (particlarLR.tripEndDate | date)
                          : "N/A"
                      }}
                    </h5>
                    <!-- <h5>{{ particlarLR?.tripStartDate ?? 'N/A' }}</h5> -->
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Trip End Date</label>
                    <h5>
                      {{
                        particlarLR?.tripEndDate
                          ? (particlarLR.tripEndDate | date)
                          : "N/A"
                      }}
                    </h5>
                    <!-- <h5>{{ particlarLR?.tripEndDate ?? 'N/A' }}</h5> -->
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Labour Loading</label>
                    <h5>
                      {{
                        particlarLR?.labourLoad ? particlarLR.labourLoad : "N/A"
                      }}
                    </h5>
                    <!-- <h5>{{ particlarLR?.tripEndDate ?? 'N/A' }}</h5> -->
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Labour Unloading</label>
                    <h5>
                      {{
                        particlarLR?.labourUnload
                          ? particlarLR.labourUnload
                          : "N/A"
                      }}
                    </h5>
                    <!-- <h5>{{ particlarLR?.tripEndDate ?? 'N/A' }}</h5> -->
                  </div>
                </div>
                <!-- Thumbnail for images -->
                <!-- <img *ngIf="file.endsWith('.png') || file.endsWith('.jpg') || file.endsWith('.jpeg')"
                                 [src]="file"
                                 alt="loading slip"
                                 class="img-thumbnail mb-1"
                                 style="width: 80px; height: auto; display: block;"> -->
                <div class="col-xl-12">
                  <label>Loading Shipping Attachment</label>

                  <div
                    *ngIf="previewLoadingSlips?.length; else noFiles"
                    class="d-flex flex-wrap gap-2"
                  >
                    <ng-container *ngFor="let file of previewLoadingSlips">
                      <a
                        [href]="file"
                        target="_blank"
                        class="attachment-badge d-flex align-items-center text-truncate mb-3"
                      >
                        <span class="me-1 text-truncate">
                          {{ file.split("/").pop() }}
                        </span>
                        <i class="bi bi-eye"></i>
                      </a>
                    </ng-container>
                  </div>

                  <ng-template #noFiles>
                    <span>No files attached</span>
                  </ng-template>
                </div>
              </div>
            </div>

            <!-- Office Use Only -->
            <div class="col-xl-12 mb-4">
              <div class="detailsBox">
                <h4>Information For Office Use Only</h4>
                <div class="row">
                  <div class="col-xl-3 mb-3">
                    <label>Vehicle Rate</label>
                    <h5>{{ particlarLR?.vehicleRate ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Advance</label>
                    <h5>{{ particlarLR?.advance ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Balance Paid</label>
                    <h5>{{ particlarLR?.balancePaid ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Actual Balance</label>
                    <h5>{{ particlarLR?.balance ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Other payment</label>
                    <h5>{{ particlarLR?.otherPayment ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Other payment Description</label>
                    <h5>{{ particlarLR?.otherPaymentDescription ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>TDS</label>
                    <h5>{{ particlarLR?.TDS ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Munsipal Amount</label>
                    <h5>{{ particlarLR?.munsipalAmount ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Final Amount</label>
                    <h5>{{ particlarLR?.finalAmount ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Detention</label>
                    <h5>{{ particlarLR?.detention ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>DLY</label>
                    <h5>{{ particlarLR?.dly_no ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Declared Value</label>
                    <h5>{{ particlarLR?.declared_value ?? "N/A" }}</h5>
                  </div>
                  <div class="col-xl-3 mb-3">
                    <label>Freight Type</label>
                    <h5>{{ particlarLR?.freightType ?? "N/A" }}</h5>
                  </div>
                </div>
              </div>
            </div>

            <!-- Invoice Details -->
            <div class="col-xl-12 mb-2">
              <div class="contentbox mt-3">
                <div class="row account">
                  <div class="col-xl-12">
                    <div
                      class="d-flex align-items-baseline justify-content-between"
                    >
                      <h1 class="fs-4 fw-bold mb-0">Invoice Details</h1>
                      <!-- <button
                              class="btn btn-dark btn-sm"
                              mat-raised-button
                              (click)="addnewinv(particlarLR?._id)"
                            >
                              + Add New Invoice
                            </button> -->
                    </div>
                  </div>

                  <div class="col-md-12 mt-3 table-responsive">
                    <!-- ✅ Show table only if invoices exist -->
                    <table
                      datatable
                      class="tablelist"
                      *ngIf="particlarLR?.invoice_no?.length > 0"
                    >
                      <thead>
                        <tr>
                          <th>Number of Articles</th>
                          <th>Invoice No</th>
                          <th>Customer Name</th>
                          <th>Invoice Value (₹)</th>
                          <th>Weight</th>
                          <!-- <th>Attachment</th> -->
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let inv of particlarLR.invoice_no">
                          <td>{{ inv.NoofArticle || "N/A" }}</td>
                          <td class="" style="padding-left: 30px">
                            {{ inv.InvoiceNo || "N/A" }}
                          </td>
                          <td class="" style="padding-left: 30px">
                            {{ inv.customerName || "N/A" }}
                          </td>
                          <td class="" style="padding-left: 30px">
                            {{ inv.InvoiceValue || "N/A" }}
                          </td>
                          <td class="" style="padding-left: 30px">
                            {{ inv.Weight || "N/A" }}
                          </td>
                          <!-- <td>
                                  <a *ngIf="inv.path" [href]="inv.path" target="_blank">View</a>
                                  <span *ngIf="!inv.path">N/A</span>
                                </td> -->
                          <td>
                            <button
                              (click)="editInvoice(inv, particlarLR?._id)"
                              class="btn btn-block p-0 shadow-none"
                            >
                              <i matTooltip="Edit" class="fas fa-pen"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- ✅ Show message if no invoice present -->
                    <div
                      *ngIf="!particlarLR?.invoice_no?.length"
                      class="text-center text-muted py-3"
                    >
                      No invoices added yet.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
